import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

/** Fades and lifts content into place the first time it scrolls into view. */
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-82" data-mp="2jqg9xwiqsy8i">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px 0px -80px 0px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 0.61, 0.36, 1]
  }} data-id="element-83" data-mp="2js9g7apg1gfz">
      {children}
    </motion.div>;
}